// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "global." + {"301":"2603163bcdeca114ea33","824":"74ef1d66f2fd71803724"}[chunkId] + ".js";
};